var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"nv-placeholder pa-0"},_vm._l((_vm.value),function(product){return _c('v-chip',{key:product,staticClass:"ma-1",class:_vm.chipStyle(product),attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm._f("enumProducts")(product,_vm.products))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }